import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
:host {
  display: block;
  height: 100%;
}

.sidebar-shell {
  width: 264px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fbfcfd;
  color: #1f2937;
  border-right: 1px solid #e5e7eb;
}

.sidebar-brand {
  height: 76px;
  padding: 18px 18px 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #edf0f3;
}

.brand-mark {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #0f766e;
  background: linear-gradient(135deg, #ccfbf1 0%, #dbeafe 100%);
  border: 1px solid rgba(15, 118, 110, 0.18);
}

.brand-mark svg {
  width: 19px;
  height: 19px;
}

.brand-copy {
  min-width: 0;
}

.brand-name {
  font-size: 15px;
  font-weight: 800;
  color: #111827;
  letter-spacing: 0;
  line-height: 1.15;
}

.brand-sub {
  margin-top: 3px;
  font-size: 11px;
  font-weight: 600;
  color: #8a94a6;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.sidebar-section {
  padding: 16px 12px 2px;
}

.section-label {
  padding: 0 8px 8px;
  font-size: 10px;
  font-weight: 800;
  color: #a0a8b5;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.nav-item {
  width: 100%;
  min-height: 40px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  border-radius: 10px;
  border: 1px solid transparent;
  background: transparent;
  color: #5b6472;
  font-size: 13px;
  font-weight: 650;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.nav-item:hover:not(.is-active):not(.is-disabled) {
  background: #f2f5f8;
  color: #111827;
}

.nav-item.is-active {
  background: #ffffff;
  color: #0f172a;
  border-color: #dce3ea;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.nav-item.is-active::before {
  content: "";
  width: 3px;
  height: 20px;
  border-radius: 999px;
  background: #0f766e;
  margin-left: -4px;
}

.nav-item.is-disabled {
  color: #c2c9d3;
  cursor: not-allowed;
}

.nav-icon {
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: inherit;
}

.nav-icon svg {
  width: 18px;
  height: 18px;
}

.nav-label {
  min-width: 0;
  flex: 1;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nav-badge {
  flex: 0 0 auto;
  padding: 2px 6px;
  border-radius: 999px;
  background: #eef6f5;
  color: #0f766e;
  font-size: 10px;
  font-weight: 800;
}

.sidebar-spacer {
  flex: 1;
  min-height: 18px;
}

.sidebar-user {
  margin: 12px;
  padding: 12px;
  border: 1px solid #e6ebef;
  border-radius: 14px;
  background: #ffffff;
}

.user-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.avatar-mark {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #eef6f5;
  color: #0f766e;
  font-size: 13px;
  font-weight: 800;
}

.user-copy {
  min-width: 0;
  flex: 1;
}

.user-name {
  font-size: 13px;
  font-weight: 750;
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-email {
  margin-top: 2px;
  font-size: 11px;
  color: #8a94a6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.logout-btn {
  width: 100%;
  margin-top: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 9px;
  border: 1px solid transparent;
  background: #f8fafc;
  color: #697386;
  font-size: 12px;
  font-weight: 700;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.logout-btn:hover {
  background: #ffffff;
  color: #111827;
  border-color: #e5e7eb;
}

.logout-btn svg {
  width: 15px;
  height: 15px;
}`],
})
export class ComponentNavSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  public router: Router) { }

    public workflowMenus: any[] = [
        {
            label: '대시보드',
            icon: 'info',
            link: '/'
        },
        {
            label: '공고 수집',
            icon: 'search',
            link: '/crawl'
        },
        {
            label: '관심 공고',
            icon: 'bookmark',
            link: '/scrap'
        },
        {
            label: '프로젝트',
            icon: 'project',
            link: '/proposal',
            badge: '목록'
        },
        {
            label: 'Codex',
            icon: 'terminal',
            link: '/codex',
            badge: '제안'
        }
    ];

    public systemMenus: any[] = [
        {
            label: '자산 관리',
            icon: 'folder',
            link: '/library'
        },
        {
            label: 'AI 설정',
            icon: 'ai',
            link: '/settings/ai'
        },
        {
            label: '요청 링크',
            icon: 'link',
            link: '/request-link'
        }
    ];

    public async ngOnInit() {
    }

    public isActive(link: string) {
        const url = this.router.url;
        if (link === '/codex') return this.isCodexRoute(url);
        if (link === '/proposal' && this.isCodexRoute(url)) return false;
        if (link === '/') return url === '/';
        return url.startsWith(link);
    }

    private isCodexRoute(url: string) {
        const path = (url || '').split('?')[0];
        if (path === '/codex' || path.startsWith('/codex/')) return true;
        if (!path.startsWith('/proposal/')) return false;
        try {
            const query = (url || '').includes('?') ? (url || '').slice((url || '').indexOf('?')) : '';
            return new URLSearchParams(query).get('codex') === '1';
        } catch {
            return false;
        }
    }

    public navClass(menu: any) {
        return this.isActive(menu.link) ? 'nav-item is-active' : 'nav-item';
    }

    public navigate(menu: any) {
        if (menu.disabled) return;
        this.service.href(menu.link);
    }

    public async logout() {
        let res = await this.service.modal.show({
            title: '로그아웃',
            message: '로그아웃 하시겠습니까?',
            action: '로그아웃',
            actionBtn: 'error',
            status: 'error'
        });
        if (res) {
            try {
                const formData = new FormData();
                await fetch('/wiz/api/page.access/logout', { method: 'POST', body: formData });
            } catch { }
            location.href = '/access';
        }
    }
}

export default ComponentNavSidebarComponent;